var _path, _path2, _g, _rect, _rect2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRegistered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 56,
    viewBox: "0 0 64 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28C0 12.536 12.5361 0 28 0C43.464 0 56.0001 12.536 56.0001 28C56.0001 43.464 43.464 56 28 56C12.5361 56 0 43.464 0 28Z",
    fill: "url(#paint0_linear_10240_248048)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10240_248048",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 30,
    height: 29
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0005 13.8542C33.3964 13.8544 37.7708 18.2287 37.771 23.6247C37.771 27.2488 35.7961 30.4096 32.8657 32.0964C34.0112 32.4539 35.1195 32.9366 36.1675 33.5417C38.6504 34.9755 40.7126 37.038 42.146 39.5212C42.4274 40.0092 42.2608 40.6338 41.7729 40.9157C41.2848 41.1974 40.6604 41.0295 40.3784 40.5417C39.1242 38.3689 37.3195 36.5638 35.147 35.3092C32.9809 34.0585 30.5239 33.3982 28.0229 33.3942C28.0155 33.3942 28.008 33.3952 28.0005 33.3952C27.9928 33.3952 27.9847 33.3942 27.977 33.3942C25.4762 33.3982 23.02 34.0587 20.854 35.3092C18.6813 36.5638 16.8768 38.3688 15.6225 40.5417C15.3407 41.0296 14.7162 41.1972 14.228 40.9157C13.7399 40.6338 13.5732 40.0094 13.855 39.5212C15.2884 37.0379 17.3504 34.9754 19.8335 33.5417C20.8811 32.9368 21.9882 32.4538 23.1333 32.0964C20.2033 30.4095 18.23 27.2484 18.23 23.6247C18.2301 18.2285 22.6043 13.8542 28.0005 13.8542ZM28.0005 15.8952C23.7319 15.8952 20.2712 19.3561 20.271 23.6247C20.271 27.8854 23.7184 31.3403 27.9761 31.3532H28.0239C32.2816 31.3403 35.73 27.8854 35.73 23.6247C35.7298 19.3563 32.2689 15.8954 28.0005 15.8952Z",
    fill: "black"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10240_248048)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.5 10.5H10.5V45.5H45.5V10.5Z",
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 33,
    width: 22,
    height: 22,
    rx: 11,
    fill: "url(#paint1_linear_10240_248048)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 33,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9336 48.9385C50.5986 48.9385 50.3525 48.8086 50.127 48.5352L47.3516 45.0693C47.1738 44.8643 47.1055 44.6729 47.1055 44.4609C47.1055 43.9961 47.4541 43.6543 47.9326 43.6543C48.2197 43.6543 48.4248 43.7568 48.6162 44.0029L50.9062 46.9561L55.3496 39.8877C55.5547 39.5732 55.7529 39.457 56.0811 39.457C56.5596 39.457 56.8945 39.7852 56.8945 40.25C56.8945 40.4346 56.8398 40.6191 56.7031 40.8311L51.7402 48.5146C51.5488 48.8018 51.2822 48.9385 50.9336 48.9385Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10240_248048",
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25BA7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B3DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10240_248048",
    x1: 52,
    y1: 34,
    x2: 52,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25BA7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B3DD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegistered);
export default __webpack_public_path__ + "static/media/registered.e2ac6c7d0810cfb4d4f7145cec4cbf3b.svg";
export { ForwardRef as ReactComponent };